import { interests } from "common/data/interests";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

interface InterestsFormProps {
  selected: any;
  setSelected: any;
}

const Wrapper = styled.div`
  width: 100%;
`;

const Text = styled.h2`
  margin-bottom: 24px;
  font-weight: 500;
  font-size: 1.8rem;
`;

const InterestsWrapper = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  gap: 24px 20px;
`;

const ButtonBasic = styled.button`
  margin-right: 20px;
  border-radius: 8px;
  padding: 15px 20px;
  cursor: pointer;
  border: none;
`;

const Button = styled(ButtonBasic)(({ selected }: { selected: boolean }) => ({
  color: selected ? "#fff" : "000",
  outline: selected ? "none" : "1px solid #B3B3B3",
  backgroundColor: selected ? `#490193` : "transparent",
}));

const InterestsForm = ({ selected, setSelected }: InterestsFormProps) => {
  const { t } = useTranslation("forms");

  return (
    <Wrapper>
      <Text>{t("chooseInterests")}</Text>
      <InterestsWrapper>
        {interests.map((interest) => (
          <Button
            key={interest}
            selected={selected[interest]}
            onClick={() => {
              setSelected((prevState: any) => ({
                ...prevState,
                [interest]: !prevState[interest],
              }));
            }}
          >
            {t(`interests:${interest}`)}
          </Button>
        ))}
      </InterestsWrapper>
    </Wrapper>
  );
};

export default InterestsForm;
